import React from 'react';
import { ReactDatePickerCustomHeaderProps, ReactDatePickerProps } from 'react-datepicker';

type RenderCustomHeaderProps = {
  startDate: ReactDatePickerProps['startDate'];
  endDate: ReactDatePickerProps['endDate'];
  isDecreaseMonth: boolean;
  isIncreaseMonth: boolean;
  isMobile: boolean;
  setIsAutoSwitchMonthRight: (value: boolean) => void;
  setIsAutoSwitchMonthLeft: (value: boolean) => void;
};

export const renderCustomHeader = ({
  startDate,
  endDate,
  isDecreaseMonth,
  isIncreaseMonth,
  isMobile,
  setIsAutoSwitchMonthRight,
  setIsAutoSwitchMonthLeft,
}: RenderCustomHeaderProps) => ({
  monthDate,
  customHeaderCount,
  decreaseMonth,
  increaseMonth,
}: ReactDatePickerCustomHeaderProps) => {
  const previousBtnHidden = !isMobile && customHeaderCount === 1;
  const nextBtnHidden = !isMobile && customHeaderCount === 0;

  if (
    (previousBtnHidden || (isMobile && customHeaderCount === 0)) &&
    endDate?.getMonth() === monthDate.getMonth() &&
    isIncreaseMonth
  ) {
    increaseMonth();
    setIsAutoSwitchMonthRight(false);
  }

  if (
    customHeaderCount === 0 &&
    startDate?.getMonth() === monthDate.getMonth() &&
    isDecreaseMonth
  ) {
    decreaseMonth();
    setIsAutoSwitchMonthLeft(false);
  }

  return (
    <div>
      <button
        type="button"
        aria-label="Previous Month"
        className="react-datepicker__navigation react-datepicker__navigation--previous"
        style={previousBtnHidden ? { visibility: 'hidden' } : undefined}
        onClick={decreaseMonth}
      >
        <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--previous">
          {'<'}
        </span>
      </button>
      <span className="react-datepicker__current-month">
        {monthDate
          .toLocaleString('ru', {
            month: 'long',
            year: 'numeric',
          })
          .slice(0, -3)}
      </span>
      <button
        type="button"
        aria-label="Next Month"
        className="react-datepicker__navigation react-datepicker__navigation--next"
        style={nextBtnHidden ? { visibility: 'hidden' } : undefined}
        onClick={increaseMonth}
      >
        <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--next">
          {'>'}
        </span>
      </button>
    </div>
  );
};
